<template>
    <!-- <app-layout> -->



    <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8 text-sm">

        <div v-if="!$page.props.canManageSettings" @click="clickRow"
            class="bg-yellow-100 text-yellow-800  border-yellow-300 sm:rounded-md px-4 py-5 sm:p-6 border mb-10 text-sm flex flex-col gap-y-4 cursor-pointer group">
            <div class="flex flex-row items-between gap-x-2">
                <div class="flex flex-row items-center gap-x-2 flex-grow">
                    <InformationCircleIcon class="w-4 h-4 mr-2" />
                    This page is read-only: You need to be connected with an Administrator profile to change these
                    settings.
                </div>
                <div class="text-sm text-yellow-800 flex items-center gap-x-2 group-hover:underline">See admins
                    <ChevronRightIcon
                        :class="[expandInfo ? 'rotate-90' : '', 'w-5 h-5 transition-transform duration-300']" />
                </div>
            </div>

            <transition name="expand" @enter="enter" @leave="leave" :css="!fixed">
                <div v-if="expandInfo" class="flex flex-row items-center gap-x-2 pl-8">
                    <ul>
                        <li v-for="admin in admins" :key="admin.email" class="py-1">
                            <a class="text-yellow-800 underline hover:text-yellow-900 text-sm"
                                :href="'mailto:' + admin.email" title="send an email">{{ admin.name }}</a>
                        </li>
                    </ul>
                </div>
            </transition>
        </div>

        <div v-if="false" class="md:grid md:grid-cols-3 md:gap-6 pt-10">

            <div class="col-span-3">

                <div class="flex flex-col items-start gap-y-3">
                    <div class="flex items-center gap-x-2">
                        <img src="/img/screen-recording.svg" class="w-6 h-6" alt="Screen Recording" />
                        <span class="font-space uppercase tracking-widest">Incoming Screen Recordings</span>
                    </div>
                    <p class="text-sm">Request recordings from your customers</p>
                </div>

            </div>
            <div class="md:mt-0 col-span-3 flex px-4 ">

                <h3 class="text-lg font-medium text-gray-900 flex flex-grow items-start gap-x-2 justify-between">
                    <div class="flex items-center flex-1 gap-x-2">
                        <!-- <div class="flex flex-col items-start gap-y-3">
                                <div class="flex items-center gap-x-2">
                                    <img src="/img/screen-recording.svg" class="w-6 h-6" alt="Screen Recording" />
                                    <span class="font-space uppercase tracking-widest">Screen Recording</span>
                                </div>
                                <p class="text-sm">Request recordings from your customers</p>
                            </div> -->


                    </div>
                    <div v-if="false" class="flex items-center">
                        <toggle :checked="has_screenrecording_enabled && plan_screenrecording" @click.prevent.stop
                            @update="toggleScreenrecording" :disabled="!plan_screenrecording"></toggle>
                    </div>
                </h3>

            </div>

        </div>


        <a name="identity" id="identity" class="pt-32"></a>
        <div class="md:grid md:grid-cols-3 md:gap-6 mt-6">

            <div class="col-span-3">
                <div class="px-4 sm:px-0 sticky self-start top-44">
                    <h3 class="text-base font-medium text-gray-900">
                        Identity
                    </h3>
                    <p class="mt-1 text-sm text-gray-700">
                        What name do you go by?
                    </p>
                </div>
            </div>

            <div class="mt-5 md:mt-0 col-span-3 flex-col gap-y-8"
                :class="{ 'pointer-events-none': !has_screenrecording_enabled || !$page.props.canManageSettings }">
                <div class="bg-white sm:rounded-md px-4 py-5 sm:p-6 border border-gray-200">
                    <identity :w_settings="widget_settings" :can_remove_branding="can_remove_branding" />
                </div>

            </div>

        </div>



        <div class="md:grid md:grid-cols-3 md:gap-6 mt-12"
            :class="{ 'pointer-events-none': !has_screenrecording_enabled || !$page.props.canManageSettings }">

            <div class="col-span-3">
                <div class="px-4 sm:px-0 sticky self-start top-44">
                    <h3 class="text-base font-medium text-gray-900">
                        Screen Recorder Appearance
                    </h3>
                    <p class="mt-1 text-sm text-gray-700">
                        What kind of vibe are you going for?
                    </p>
                </div>
            </div>


            <div class="mt-5 md:mt-0 col-span-3 flex-col gap-y-8">


                <div class="bg-white sm:rounded-md px-4 py-5 sm:p-6 border border-gray-200">
                    <a name="color" id="color" />
                    <recorder-color :w_settings="widget_settings" />
                </div>

            </div>

        </div>



        <a name="powered-by-ai" id="powered-by-ai" class="pt-32" />
        <div class="md:grid md:grid-cols-3 md:gap-6 mt-12"
            :class="{ 'pointer-events-none': !has_screenrecording_enabled || !$page.props.canManageSettings }">

            <div class="col-span-3">
                <div class="px-4 sm:px-0 sticky self-start top-44">
                    <h3 class="text-base font-medium text-gray-900">
                        Powered by AI
                    </h3>
                </div>
            </div>


            <div class="mt-5 md:mt-0 col-span-3 flex-col gap-y-8">


                <div class="bg-white sm:rounded-md px-4 py-5 sm:p-6 border border-gray-200">

                    <powered-ai :transcribing_enabled="transcribing_enabled" :plan_transcribing="plan_transcribing" />
                </div>

            </div>

        </div>


        <a name="console" id="console" class="pt-32" />
        <div class="md:grid mcol-span-3 md:gap-6 mt-12"
            :class="{ 'pointer-events-none': !has_screenrecording_enabled || !$page.props.canManageSettings }">

            <div class="col-span-3">
                <div class="px-4 sm:px-0 sticky self-start top-44">
                    <h3 class="text-base font-medium text-gray-900">
                        Console logs
                    </h3>
                    <p class="mt-1 text-sm text-gray-700">
                        <a :href="route('settings.index') + '#snippet'" title="Birdie snippet"
                            class="text-sm italic text-birdie-blue hover:underline">Birdie snippet is required</a>
                    </p>
                </div>
            </div>


            <div class=" col-span-3 flex-col gap-y-8">


                <div class="bg-white sm:rounded-md px-4 py-5 sm:p-6 border border-gray-200">

                    <console-logs :console_enabled="console_enabled" :plan_console="plan_console" />
                </div>

            </div>

        </div>


        <a name="snippet" id="snippet" class="pt-32"></a>
        <div class="md:grid md:grid-cols-3 md:gap-6 mt-12">

            <div class="col-span-3 flex justify-between items-end">
                <div class="px-4 sm:px-0 sticky self-start top-44 flex-grow">
                    <h3 class="text-base font-medium text-gray-900">
                        Snippet
                    </h3>
                    <p class="mt-1 text-sm text-gray-700">
                        Install the Birdie snippet if you want to collect logs and/or hide sensitive data
                    </p>
                </div>

                <div v-if="has_installed_snippet"
                    class="flex items-center gap-2 text-birdie-green font-bold flex-shrink-0">
                    Installed
                    <CheckCircleIcon class="w-5 h-5" />
                </div>
                <div v-else class="flex items-center gap-2 text-gray-500 flex-shrink-0">
                    Not installed
                    <XCircleIcon class="w-5 h-5" />
                </div>

            </div>

            <div class="mt-5 md:mt-0 col-span-3 flex-col gap-y-8">
                <div class="bg-white sm:rounded-md px-4 py-5 sm:p-6 border border-gray-200">
                    <SnippetDetail :blur_snippet="blur_snippet" :has_installed_snippet="has_installed_snippet"
                        :npm_init_snippet="npm_init_snippet" />
                </div>

            </div>

        </div>



        <a name="forward" id="forward" class="pt-32" />
        <div class="md:grid md:grid-cols-3 md:gap-6 mt-12"
            :class="{ 'pointer-events-none opacity-60': !has_screenrecording_enabled }">

            <div class="col-span-3">
                <div class="px-4 sm:px-0 sticky self-start top-44">
                    <h3 class="text-base font-medium text-gray-900">
                        Forward recordings
                    </h3>
                    <p class="mt-1 text-sm text-gray-700">
                        Make it work your way
                    </p>
                </div>
            </div>


            <div class="mt-5 md:mt-0 col-span-3 flex-col gap-y-8">


                <div class="bg-white sm:rounded-md px-4 py-5 sm:p-6 border border-gray-200">

                    <trigger-webhook :the_webhook="webhook" :plan_api="plan_api"
                        :temp_webhook_secret="temp_webhook_secret" :last_call="last_call">
                    </trigger-webhook>
                    <jet-section-border />


                    <trigger-email :email="$page.props.user.email" :inapp="notify_inapp_video_received"
                        :link="notify_link_used">
                    </trigger-email>
                    <jet-section-border />

                    <trigger-slack :the_trigger="trigger_slack">
                    </trigger-slack>
                    <jet-section-border />

                    <trigger-zapier :the_trigger="trigger_zapier">
                    </trigger-zapier>

                </div>

            </div>

        </div>


        <a name="rules" id="rules" class="pt-32" />
        <div class="md:grid md:grid-cols-3 md:gap-6 mt-12"
            :class="{ 'pointer-events-none': !has_screenrecording_enabled || !$page.props.canManageSettings }">
            <div class="col-span-3">
                <div class="px-4 sm:px-0 sticky self-start top-44">
                    <h3 class="text-base font-medium text-gray-900">
                        Routing Rules for Folders
                    </h3>
                    <p class="mt-1 text-sm text-gray-700">
                        Set up rules to automatically send recordings to the right folder - <docs-link
                            href="https://docs.birdie.so/birdie-docs/request-screen-recordings/misc./routing-rules-for-folders" />
                    </p>
                </div>
            </div>

            <div class="mt-5 md:mt-0 col-span-3 flex-col gap-y-8">
                <div class="bg-white sm:rounded-md px-4 py-5 sm:p-6 border border-gray-200">
                    <rules :rules="rules" :folders="folders" :plan_rules="plan_rules" />
                </div>
            </div>
        </div>



        <a name="websdk" id="websdk" class="pt-32" />
        <div class="md:grid md:grid-cols-3 md:gap-6 mt-12"
            :class="{ 'pointer-events-none opacity-60': !has_screenrecording_enabled }">

            <div class="col-span-3">
                <div class="px-4 sm:px-0 sticky self-start top-44">
                    <h3 class="text-base font-medium text-gray-900">
                        Web SDK
                    </h3>
                    <p class="mt-1 text-sm text-gray-700">
                        Open Birdie recorder from a specific button, link or element in your web app!
                    </p>
                </div>
            </div>


            <div class="mt-5 md:mt-0 col-span-3 flex-col gap-y-8">

                <div class="bg-white sm:rounded-md px-4 py-5 sm:p-6 border border-gray-200">

                    <WebSdk :team_slug="team_slug" :team_name="team_name" :snippet_original="snippet_original"
                        :has_installed_widget="has_installed_widget" />
                </div>

            </div>

        </div>


    </div>


</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import RecorderColor from '@/Components/Settings/RecorderColor'
import TriggerEmail from '@/Components/Settings/Triggers/TriggerEmail'
import TriggerSlack from '@/Components/Settings/Triggers/TriggerSlack'
import TriggerZapier from '@/Components/Settings/Triggers/TriggerZapier'
import JetSectionBorder from '@/Jetstream/SectionBorder'
import WebSdk from '@/Components/Settings/WebSdk'
import ConsoleLogs from '@/Components/Settings/ConsoleLogs'
import PoweredAi from '@/Components/Settings/PoweredAi'
import Rules from '@/Components/Settings/Rules'
import Toggle from '@/Components/UI/Toggle'
import Identity from '@/Components/Settings/Identity'
import SnippetDetail from '@/Components/Settings/SnippetDetail'
import { InformationCircleIcon, ChevronRightIcon } from "@heroicons/vue/16/solid"
import { CheckCircleIcon } from "@heroicons/vue/24/solid"
import { XCircleIcon } from "@heroicons/vue/24/outline"
import { nextTick } from 'vue';
import TriggerWebhook from '@/Components/Settings/Triggers/TriggerWebhook'



export default {
    props: ["widget_settings", "trigger_zapier", "trigger_slack",
        "notify_inapp_video_received", "notify_link_used", "team_slug",
        "team_name", "snippet_original", "plan_console", "console_enabled",
        "has_installed_widget", "plan_transcribing", "transcribing_enabled",
        "screenrecording_enabled", "plan_screenrecording",
        "blur_snippet", "npm_init_snippet", "has_installed_snippet", "can_remove_branding", "admins",
        "folders", "plan_rules", "rules", "webhook", "plan_api", "temp_webhook_secret", "last_call"
    ],

    components: {
        AppLayout, RecorderColor, TriggerEmail, JetSectionBorder,
        TriggerSlack, TriggerZapier, WebSdk, ConsoleLogs, Toggle, PoweredAi,
        Identity, SnippetDetail, InformationCircleIcon, ChevronRightIcon, Rules,
        CheckCircleIcon, XCircleIcon, TriggerWebhook
    },

    layout: AppLayout,

    data() {
        return {
            saving: false,
            has_screenrecording_enabled: this.screenrecording_enabled && this.plan_screenrecording,
            expandInfo: false,
        }
    },
    created() {
    },
    beforeUnmount() {
    },
    mounted() {
        const params = new URLSearchParams(window.location.search);
        const target = params.get('goto');
        if (!target) return;
        nextTick(() => {
            const el = document.getElementById(target);

            if (el) {
                el.scrollIntoView({ behavior: 'smooth' });
            } else {
                setTimeout(() => {
                    const retryEl = document.getElementById(target);
                    if (retryEl) {
                        retryEl.scrollIntoView({ behavior: 'smooth' });
                    } else {
                    }
                }, 200);
            }
        });
    },
    methods: {
        clickRow: function () {
            this.expandInfo = !this.expandInfo
        },
        toggleScreenrecording: function () {
            if (!this.plan_screenrecording || this.saving) {
                return
            }
            this.has_screenrecording_enabled = !this.has_screenrecording_enabled
            this.updateMeta({
                meta: "screenrecording_enabled",
                value: this.has_screenrecording_enabled
            })

        },
        updateMeta: function (params) {
            this.saving = true
            let url = this.$page.props.api_url + '/v1/team/set_meta';
            axios.post(url, params)
                .then(response => {
                    let options = {
                        type: "default",
                        timeout: 2500,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("Setting updated", options)
                    this.saving = false
                })
                .catch(e => {
                    console.error(e);
                    this.saving = false
                });
        },
        enter(element) {
            const width = getComputedStyle(element).width;
            element.style.width = width;
            element.style.position = 'absolute';
            element.style.visibility = 'hidden';
            element.style.height = 'auto';

            const height = getComputedStyle(element).height;
            element.style.width = null;
            element.style.position = null;
            element.style.visibility = null;
            element.style.height = 0;

            // Force repaint
            getComputedStyle(element).height;

            // Add transition
            element.style.height = height;
        },

        leave(element) {

            const height = getComputedStyle(element).height;
            element.style.height = height;

            // Force repaint
            getComputedStyle(element).height;

            // Add transition
            element.style.height = 0;
        }
    }
}
</script>
<style scoped>
.expand-enter-active,
.expand-leave-active {
    transition: height 0.3s ease-in-out;
    overflow: hidden;
}

.expand-enter-from,
.expand-leave-to {
    height: 0;
}
</style>
